export const REMOVE_EXPLORE_REPORTER_FIELDS_FROM_YEAR = 2026;
export const REMOVE_OUTBOUND_EXCHANGE_STUDENTS_FROM_YEAR = 2027;
